export const CATALOG_ITEMS_ENDPOINTS = {
  SCHEMA: (sysId: string) =>
    `catalog-items/${encodeURIComponent(sysId)}/schema`,
  REQUESTS: (sysId: string) =>
    `catalog-items/${encodeURIComponent(sysId)}/requests`,
} as const;
